import { Outlet } from 'react-router-dom';

export function DeliveryApprovalsPage() {
  return <Outlet />;
}

export default DeliveryApprovalsPage;
